module.exports = __webpack_public_path__ + "static/v1.e-thumb-e3f498f5e0a9f05e88a6c3306c5a6310.jpg";